import AppQuestions from "candidate/Application/Questions";
import AppSummary from "candidate/Application/ApplicationSummary";
import CandidateMyApplications from "candidate/CandidateMyApplications";
import CandidateHome from "candidate/Home";
import CandidateOnboard from "candidate/Onboard";
import CandidateStartDate from "candidate/Feedback/CandidateStartDate";
import CandidateQuestions from "candidate/ProfileQuestions";
import CandidateUpdatePhone from "candidate/Feedback/CandidateUpdatePhone";
import WorkforceSurveySignUp from "workforce/SurveySignUp";
import authStore from "redux/auth";
import candidateStore from "redux/candidate";
import AppContainer from "apps/components/AppContainer";

import createApp from "./createApp";

const COMPONENT_MAP = {
    APPLICATION_QUESTIONS: {
        Component: AppQuestions,
        store: candidateStore,
    },
    APPLICATION_SUMMARY: {
        Component: AppSummary,
        store: candidateStore,
    },
    HOME: {
        Component: CandidateHome,
        store: candidateStore,
    },
    MY_APPS: {
        Component: CandidateMyApplications,
        store: candidateStore,
    },
    ONBOARD: {
        Component: CandidateOnboard,
        store: candidateStore,
    },
    START_DATE: {
        Component: CandidateStartDate,
        store: candidateStore,
    },
    QUESTIONS: {
        Component: CandidateQuestions,
        store: candidateStore,
    },
    UPDATE_PHONE: {
        Component: CandidateUpdatePhone,
        store: candidateStore,
    },
    WORKFORCE_SURVEY_SIGN_UP: {
        Component: WorkforceSurveySignUp,
        store: authStore,
    },
};

export const init = createApp(AppContainer, COMPONENT_MAP, "candidate");
